import React, { useRef, useState, useEffect } from 'react';

declare global {
  namespace JSX {
    interface IntrinsicElements {
      'tableau-viz': React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement> & {
        id?: string;
        src?: string;
        token?: string;
        device?: string;
        toolbar?: string;
        height?: string;
        width?: string;
        'hide-tabs'?: string;
      };
    }
  }
}

interface TableauVizProps {
  url: string;
  token: string; 
  onTabsLoaded: (tabs: string[]) => void;
  onError: (error: string) => void;
}

const TableauViz: React.FC<TableauVizProps> = ({ url, token, onTabsLoaded, onError }) => {
    const vizRef = useRef<any>(null);
    const [isScriptLoaded, setIsScriptLoaded] = useState(false);
  
    useEffect(() => {
      // Load Tableau Embedding API
      const script = document.createElement("script");
      script.type = "module";
      script.src = "https://us-east-1.online.tableau.com/javascripts/api/tableau.embedding.3.latest.min.js";
      script.onload = () => {
        console.log("Tableau Embedding API script loaded");
        setIsScriptLoaded(true);
      };
      script.onerror = () => {
        console.error("Failed to load Tableau Embedding API script");
        onError("Failed to load Tableau script");
      };
      document.head.appendChild(script);
  
      return () => {
        document.head.removeChild(script);
      };
    }, [onError]);
  
    useEffect(() => {
      if (!isScriptLoaded) return;
  
      const handleFirstInteractive = () => {
        console.log("firstinteractive event fired");
        if (vizRef.current && vizRef.current.workbook) {
          try {
            const workbook = vizRef.current.workbook;
            
            // Get the active sheet
            const activeSheet = workbook.activeSheet;
            const activeSheetName = activeSheet.name;
            // setCurrentActiveTab(activeSheetName);
            console.log(activeSheetName,'activeSheetName');
            
            
            // Get all published sheets (tabs)
            const publishedSheets = workbook.publishedSheetsInfo;
            console.log("Available tabs:", publishedSheets);
            
            if (publishedSheets && publishedSheets.length > 0) {
              // Extract and format sheet information
              const sheetsInfo = publishedSheets.map((sheet: any) => ({
                name: sheet.name,
                id: sheet.sheetId || sheet.id,
                url: sheet.url,
                isActive: sheet.name === activeSheetName
              }));
              
              console.log("Formatted tab information:", sheetsInfo);
              sheetsInfo
              console.log(sheetsInfo,'sheetsInfo');
              
              // If we have more than one sheet, we know the dashboard has tabs
              if (sheetsInfo.length > 1) {
                console.log("Dashboard has multiple tabs");
                onTabsLoaded(sheetsInfo);
              }
            }
          } catch (error) {
            console.error("Error extracting tab information:", error);
          }
        }
      };
  
      const handleVizError = (event: any) => {
        console.error("Tableau viz error:", event);
        onError(`Tableau visualization error: ${event.detail || event.message || "Unknown error"}`);
      };
  
      // Attach event listeners
      const vizElement = document.getElementById("tableauViz");
      if (vizElement) {
        vizRef.current = vizElement;
        vizElement.addEventListener("firstinteractive", handleFirstInteractive);
        vizElement.addEventListener("error", handleVizError);
      } else {
        onError("Tableau viz element not found in DOM");
      }
  
      return () => {
        if (vizElement) {
          vizElement.removeEventListener("firstinteractive", handleFirstInteractive);
          vizElement.removeEventListener("error", handleVizError);
        }
      };
    }, [isScriptLoaded, onTabsLoaded, onError]);
  
    console.log("testing",isScriptLoaded);
    
    if (!isScriptLoaded) return null;
  
    return (
      <div style={{ position: "absolute", visibility: "hidden" }}>
        {React.createElement('tableau-viz', {
          id: "tableauViz",
          src: url,
          token: token,
          device: "desktop",
          toolbar: "hidden",
          height: "100px",
          width: "100px"
        })}
      </div>
    );
};

  export default TableauViz;